var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Headline, Icon } from '@folio/stripes/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getWeekdaySpan, WEEKDAYS } from '../../utils/WeekdayUtils';
import css from './HoursAndExceptionFields.css';
import RowType from './RowType';
export function rowsToOpenings(providedRows, localeWeekdays) {
    var providedOpenings = providedRows
        .filter(function (row) {
        return (row.startDay !== undefined &&
            row.startTime !== undefined &&
            row.endDay !== undefined &&
            row.endTime !== undefined);
    })
        .map(function (row) { return ({
        startDay: row.startDay,
        startTime: row.startTime,
        endDay: row.endDay,
        endTime: row.endTime
    }); });
    var firstWeekday = WEEKDAYS[localeWeekdays[0].weekday];
    providedOpenings.sort(function (a, b) {
        if (a.startDay !== b.startDay) {
            return (((WEEKDAYS[a.startDay] - firstWeekday + 7) % 7) -
                ((WEEKDAYS[b.startDay] - firstWeekday + 7) % 7));
        }
        return a.startTime.localeCompare(b.endTime);
    });
    return providedOpenings;
}
export function calculateInitialRows(providedRows, localeWeekdays) {
    var providedOpenings = rowsToOpenings(providedRows, localeWeekdays);
    var count = 0;
    // Find all weekdays
    var weekdaysTouched = {
        SUNDAY: false,
        MONDAY: false,
        TUESDAY: false,
        WEDNESDAY: false,
        THURSDAY: false,
        FRIDAY: false,
        SATURDAY: false
    };
    providedOpenings.flatMap(getWeekdaySpan).forEach(function (weekday) {
        weekdaysTouched[weekday] = true;
    });
    var rows = [];
    var weekdays = localeWeekdays.map(function (weekday) { return weekday.weekday; });
    var openingIndex = 0;
    for (var weekdayIndex = 0; weekdayIndex < weekdays.length; weekdayIndex++) {
        if (weekdaysTouched[weekdays[weekdayIndex]]) {
            while (openingIndex < providedOpenings.length &&
                providedOpenings[openingIndex].startDay === weekdays[weekdayIndex]) {
                rows.push(__assign({ i: count, type: RowType.Open }, providedOpenings[openingIndex]));
                openingIndex++;
                count++;
            }
        }
        else {
            var endingWeekdayIndex = weekdayIndex;
            // while the days after this one have not been touched
            while (endingWeekdayIndex + 1 < weekdays.length &&
                !weekdaysTouched[weekdays[endingWeekdayIndex + 1]]) {
                endingWeekdayIndex++;
                // touch them to prevent double loops in future
                weekdaysTouched[weekdays[endingWeekdayIndex]] = true;
            }
            rows.push({
                type: RowType.Closed,
                i: count,
                startDay: weekdays[weekdayIndex],
                startTime: undefined,
                endDay: weekdays[endingWeekdayIndex],
                endTime: undefined
            });
            count++;
        }
    }
    return { rows: rows, count: count };
}
export function isRowConflicted(error, rowIndex) {
    var _a;
    return !!((_a = error === null || error === void 0 ? void 0 : error.conflicts) === null || _a === void 0 ? void 0 : _a.has(rowIndex));
}
export function getWeekdayError(key, error, rowIndex, submitAttempted, touched) {
    var _a, _b;
    if (!submitAttempted && !touched) {
        return undefined;
    }
    return (_b = (_a = error === null || error === void 0 ? void 0 : error.empty) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b[rowIndex];
}
export function getTimeError(key, error, rowIndex, submitAttempted, touched) {
    var _a, _b;
    if ((!submitAttempted && !touched) || error === undefined) {
        return undefined;
    }
    return ((_a = error.empty) === null || _a === void 0 ? void 0 : _a[key][rowIndex]) || ((_b = error.invalidTimes) === null || _b === void 0 ? void 0 : _b[key][rowIndex]);
}
export function getConflictError(error) {
    var _a;
    if (!((_a = error === null || error === void 0 ? void 0 : error.conflicts) === null || _a === void 0 ? void 0 : _a.size)) {
        return undefined;
    }
    return (React.createElement(Headline, { margin: "none", className: css.conflictMessage, weight: "medium", size: "medium" },
        React.createElement(Icon, { icon: "exclamation-circle", status: "error" }),
        React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.error.openingConflictError" })));
}
